import { lazy } from 'react';

const routeConfig = [{
  path: '',
  component: lazy(() => import('./Home'))
}];

export default routeConfig;